/*
 * PDP offer block — snippets/cdt-pdp-offer.liquid
 *
 * Two jobs, both progressive enhancement: if either source is missing the
 * corresponding line simply stays hidden, which is why both start [hidden]
 * rather than rendering a placeholder.
 *
 *  1. "N% dintre clienți recomandă produsul", computed from the Judge.me
 *     histogram (4★ + 5★ over the total). The average rating ALONE cannot give
 *     this number, so there is no fallback that would be honest — no histogram,
 *     no line. The widget loads async and lazily, hence the observer.
 *
 *  2. The rating caption, rewritten from Judge.me's "4.8 (19)" to eMAG's
 *     "4,8 (19 review-uri)" — PDP only, and declining the noun for n === 1.
 *
 *  3. Keeping the Klarna instalment placement on the SELECTED variant's price.
 */
(function () {
  'use strict';

  /* ---------- 1. social proof ---------- */
  function paintSocial() {
    var out = document.querySelector('[data-cdt-po-social]');
    if (!out || out.dataset.done === '1') return false;

    var rows = document.querySelectorAll('.jdgm-histogram__row[data-rating][data-frequency]');
    if (!rows.length) return false;

    var total = 0, happy = 0;
    for (var i = 0; i < rows.length; i++) {
      var stars = parseInt(rows[i].getAttribute('data-rating'), 10);
      var n = parseInt(rows[i].getAttribute('data-frequency'), 10);
      if (isNaN(stars) || isNaN(n)) continue;
      total += n;
      if (stars >= 4) happy += n;
    }
    /* Under ~10 reviews a percentage is noise dressed up as data. */
    if (total < 10) { out.dataset.done = '1'; return true; }

    var pct = Math.round((happy / total) * 100);
    if (pct < 70) { out.dataset.done = '1'; return true; }   // don't advertise a weak number

    out.textContent = pct + '% dintre clienți recomandă produsul';
    out.hidden = false;
    out.dataset.done = '1';
    return true;
  }

  /* ---------- 2. rating caption ---------- */
  /* Judge.me renders "4.8 (19)" from its own template setting
     `{{ average_rating_1_decimal }} ({{ n }})`. eMAG writes the noun out:
     "4.66 (350 review-uri)".

     Done here in the DOM rather than by patching window.jdgmSettings, for two
     reasons: the setting is global, so it would also rewrite the collection
     tiles (which are meant to stay compact "4.9 (195)"), and a static template
     cannot decline the noun — it would print "1 review-uri". */
  function paintRating() {
    var badge = document.querySelector('.jdgm-preview-badge');
    if (!badge) return false;

    var data = badge.querySelector('.jdgm-prev-badge');
    var out = badge.querySelector('.jdgm-prev-badge__text');
    if (!data || !out) return false;

    var n = parseInt(data.getAttribute('data-number-of-reviews'), 10);
    var avg = parseFloat(data.getAttribute('data-average-rating'));
    if (isNaN(n) || isNaN(avg) || n <= 0) return false;

    var noun = n === 1 ? 'review' : 'review-uri';
    var want = avg.toFixed(1) + ' (' + n + ' ' + noun + ')';

    /* Only write on a real difference — Judge.me re-renders the badge, and an
       unconditional write would bounce off our own MutationObserver forever. */
    if (out.textContent.trim() !== want) out.textContent = want;
    return true;
  }

  function tick() {
    paintSocial();
    paintRating();
  }

  /* ---------- 3. Klarna instalments follow the variant ---------- */
  function wireKlarna() {
    var el = document.querySelector('[data-cdt-klarna]');
    if (!el) return;

    /* Same event cdt-gallery.js and the frequently-bought-together block use.
       Not a change listener on [name="id"]: the theme swaps variants through
       its own selector and that input is not always what moves. */
    var vs = document.querySelector('[data-variant-selection]');
    if (!vs) return;

    vs.addEventListener('variant-change', function (e) {
      var v = e.detail && e.detail.variant;
      if (!v || !v.price) return;
      if (el.getAttribute('data-purchase-amount') === String(v.price)) return;
      el.setAttribute('data-purchase-amount', String(v.price));
      /* Klarna re-reads the attribute only on refresh(). Guarded because the
         library is an app embed we do not control and may not have loaded. */
      try {
        if (window.Klarna && window.Klarna.OnsiteMessaging && window.Klarna.OnsiteMessaging.refresh) {
          window.Klarna.OnsiteMessaging.refresh();
        }
      } catch (err) { /* noop */ }
    });
  }

  function start() {
    tick();
    wireKlarna();

    /* Observe for a fixed window rather than stopping at the first success.
       Judge.me paints the badge and then re-paints it (the node starts
       display:none and is revealed later), so disconnecting as soon as both
       jobs reported OK meant our caption was written and then overwritten
       straight back to "4.8 (19)". Both writes are difference-guarded, so
       re-asserting cannot bounce off our own observer. */
    var obs = new MutationObserver(tick);
    obs.observe(document.body, { childList: true, subtree: true });

    /* Belt and braces for renders that mutate nothing we can see. */
    [400, 1200, 3000, 8000].forEach(function (ms) { setTimeout(tick, ms); });

    setTimeout(function () { obs.disconnect(); }, 20000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
